import { ExtractPropTypes, PropType } from "vue";

export const UiDateRangePickerPropsOption = {
    classExtraName: { type: String, default: "" },
    placeholder: { type: Object as PropType<{ start: string; end: string }>, default: { start: "开始时间", end: "结束时间" } },
    modelValue: { type: Object as PropType<{ start?: Date; end?: Date }>, required: true },
    separator: { type: String, default: "至" },
    confirm: { type: String, default: "确定" },
    zIndex: { type: Number, default: 66 },
    detach: { type: Boolean, default: true }, //* 选择器是否当前文档流
    width: { type: [String, Number] as PropType<number | string>, default: 264 },
    mode: { type: String as PropType<"date" | "time">, default: "date" },
    name: { type: String, default: "" },
} as const;

export type UiDateRangePickerProps = ExtractPropTypes<typeof UiDateRangePickerPropsOption>;

export const UiDateRangePickerEmits = {
    "update:modelValue": (_data: { start?: Date; end?: Date }) => true,
    "before-enter": () => true,
    "before-leave": () => true,
    "after-enter": () => true,
    "after-leave": () => true,
    "change": (_date: { start: Date; end: Date }) => true,
};
